<template>
  <div class="">
    <div class="">
      <q-btn color="dark" label="menu and accessibility options" class="menu-btn">

        <q-menu fit anchor="bottom middle" self="top middle" no-focus="true" max-height="80%">
          <q-list style="min-width:110px">
           <q-item>
            <b>Sections</b>
            </q-item>
           <a @click="menuNav" href="#SuitableForRoute"> <q-item clickable>
          Who is a suitable applicant for this route?
            </q-item></a>
             <a @click="menuNav" href="#HowRecognisedViaDialogue"><q-item clickable>
           How is the colleague recognised via dialogue?
            </q-item></a> 
             <a @click="menuNav" href="#MentorDuties"><q-item clickable>
           Mentor duties
            </q-item></a>
             <a @click="menuNav" href="#DeferOrAward"><q-item clickable>
           Defer or award
            </q-item></a>
          </q-list>
        <q-separator />
            <q-item><b>Card background colours</b></q-item>
             <q-item @click="accessibleBackgroundColour('#fafafa')" clickable>Off-white</q-item>
             <q-item @click="accessibleBackgroundColour('#dbe1f1')" clickable>Blue Grey</q-item>
             <q-item @click="accessibleBackgroundColour('#f6f6f6')" clickable>Grey</q-item>
             <q-item @click="accessibleBackgroundColour('#edd1b0')" clickable>Peach</q-item>
             <q-item @click="accessibleBackgroundColour('#f8fd89')" clickable>Yellow</q-item>
        <q-separator />

            <q-item><b>background colours</b></q-item>
             <q-item @click="BackgroundColourYellow('#fafafa')" clickable>Off-White</q-item>
             <q-item @click="BackgroundColourYellow('#002F6C')" clickable>Blue</q-item>
             <q-item @click="BackgroundColourYellow('#FFCD00')" clickable>Yellow</q-item>
             <q-item @click="BackgroundColourYellow('#00C1D4')" clickable>Aqua</q-item>
             <q-item @click="BackgroundColourYellow('#505759')" clickable>Grey</q-item>
        <q-separator />
            <q-item><b>Font size</b></q-item>
            <q-item><q-slider
            v-model="value"
            @change="changeDate"
            :min="0"
            :max="50"
            :step="1"
            label
            :label-value="'Value: ' + value + 'px'"
            label-always    
            color="primary"
            /></q-item>
            <q-separator />
            <q-item  class="animationOnOff"><b>Toggle animation</b></q-item>
            <q-item>      
        <q-toggle
        v-model="onOffSwitch"
        @click="animationtoggle"
        checked-icon="check"
        color="green"
        unchecked-icon="clear"
      /></q-item>
        </q-menu>
      </q-btn>
    </div>
  </div>
</template>



<script>
import { ref } from '@vue/reactivity'

export default {
setup(prompts, {emit}) {
   

    const value = ref(20)

    const onOffSwitch = ref(false)

    const menuNav = () => {
        const sectionAnimation = document.querySelectorAll('section')
        sectionAnimation.forEach(i => i.classList.remove("hide-five"))
    }

    const animationtoggle = () => {
      if(onOffSwitch.value === true) {
        const sectionAnimation = document.querySelectorAll('section')
        sectionAnimation.forEach(i => i.classList.remove("hide-five"))
      } 
    } 

    const changeDate = () => {
      const para = document.querySelectorAll('p')

      para.forEach(i => i.style.fontSize = value.value + "px")
    }

    const accessibleBackgroundColour = (colour) => {
        const background = document.querySelectorAll(".container-section");
        const backgroundColour = document.querySelectorAll(".background-colour");
        background.forEach(i => i.style.backgroundColor = colour)
        backgroundColour.forEach(i => i.style.backgroundColor = colour)
    }

    const BackgroundColourYellow = (colour) => {
        const footer = document.querySelector(".footer");
        const logo = document.querySelector(".logo");
        const bannerText = document.querySelectorAll(".container-quote-banner");
        const headerOne = document.querySelector("h1");
        const background = document.querySelector(".container-main");
        background.style.backgroundColor = colour
        const BeforeAfterQuoteShade = document.querySelectorAll(".quoteBeforeAfter, svg");

        // FOOTER BACKGROUND COLOUR

        if(colour ===  '#FFCD00') {
          footer.style.backgroundColor = '#F6A800'
          logo.style.fill = '#303030'
          bannerText.forEach(i => i.style.color = '#303030')
          headerOne.style.color = '#303030' 
          BeforeAfterQuoteShade.forEach(i => i.style.setProperty("--mmuYellowShade", "#F6A800"))
        }
        if(colour ===  '#00C1D4') {
          footer.style.backgroundColor = '#0092B3'
          logo.style.fill = '#303030'
          bannerText.forEach(i => i.style.color = '#303030')
          headerOne.style.color = '#303030' 
          BeforeAfterQuoteShade.forEach(i => i.style.setProperty("--mmuYellowShade", "#0092B3"))
        }
        if(colour ===  '#505759') {
          footer.style.backgroundColor = '#243835'
          logo.style.fill = '#fafafa'
          bannerText.forEach(i => i.style.color = '#fafafa')
          headerOne.style.color = '#fafafa' 
          BeforeAfterQuoteShade.forEach(i => i.style.setProperty("--mmuYellowShade", "#243835"))
        }
        if(colour ===  '#002F6C') {
          footer.style.backgroundColor = '#1E2B50'
          logo.style.fill = '#fafafa'
          bannerText.forEach(i => i.style.color = '#fafafa')
          headerOne.style.color = '#fafafa'
          BeforeAfterQuoteShade.forEach(i => i.style.setProperty("--mmuYellowShade", "#B2BED4"))

        }
        if(colour ===  '#fafafa') {
          footer.style.backgroundColor = '#303030'
          logo.style.fill = '#303030'
          bannerText.forEach(i => i.style.color = '#303030')
          headerOne.style.color = '#303030' 
          BeforeAfterQuoteShade.forEach(i => i.style.setProperty("--mmuYellowShade", "#303030"))

        }
    }

    return { accessibleBackgroundColour, value, changeDate, BackgroundColourYellow, onOffSwitch, animationtoggle, menuNav }
}
}
</script>


<style lang="scss" scoped>
.q-menu {
  a {
    margin: 0;
    padding: 0;
    color: #303030;
  }

  .q-item {
        padding: 16px 16px;
  }
}

.animationOnOff .q-item {
  margin: 0 !important;
}
</style>